"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("fabric");
var constants_1 = require("../common/constants");
var fabric_2 = __importDefault(require("../utils/fabric"));
var Base_1 = __importDefault(require("./Base"));
var Frame = /** @class */ (function (_super) {
    __extends(Frame, _super);
    function Frame(props) {
        var _this = _super.call(this, props) || this;
        _this.setHoverCursor = function (cursor) {
            var background = _this.background;
            if (background) {
                background.set("hoverCursor", cursor);
            }
        };
        _this.setBackgroundColor = function (color) {
            // Remove any existing background image first
            var objects = _this.canvas.getObjects();
            var bgImage = objects.find(function (object) { return object.type === constants_1.LayerType.BACKGROUND_IMAGE; });
            if (bgImage) {
                _this.canvas.remove(bgImage);
            }
            var background = _this.background;
            if (!background) {
                // Background was removed when an image background was set — recreate it
                background = new fabric_1.fabric.Background(__assign(__assign({}, constants_1.defaultBackgroundOptions), { width: _this.frame.width, height: _this.frame.height, shadow: _this.config.shadow }));
                _this.canvas.add(background);
                background.center();
                // Place at index 1 (right above the Frame at index 0)
                background.moveTo(1);
            }
            background.set({ fill: color });
            _this.canvas.requestRenderAll();
            _this.editor.history.save();
        };
        _this.setBackgroundImage = function (imageUrl) {
            fabric_1.fabric.Image.fromURL(imageUrl, function (img) {
                var scaleX = (_this.frame.width / img.width) * 1.25;
                var scaleY = _this.frame.height / img.height;
                var scale = Math.max(scaleX, scaleY);
                img.set({
                    type: constants_1.LayerType.BACKGROUND_IMAGE,
                    scaleX: scaleX,
                    scaleY: scaleY
                });
                // Center the image on the canvas
                img.set({
                    left: _this.canvas.getWidth() / 2 - img.getScaledWidth() / 2,
                    top: _this.canvas.getHeight() / 2 - img.getScaledHeight() / 2,
                    originX: 'left',
                    originY: 'top'
                });
                var objects = _this.canvas.getObjects();
                var backgroundIndex = objects.findIndex(function (object) { return object.type === constants_1.LayerType.BACKGROUND_IMAGE || object.type === constants_1.LayerType.BACKGROUND; });
                if (backgroundIndex !== -1) {
                    _this.canvas.remove(objects[backgroundIndex]);
                }
                // Add the image to the canvas
                _this.canvas.add(img);
                _this.canvas.sendToBack(img);
                _this.canvas.requestRenderAll();
            }, { crossOrigin: "anonymous" });
        };
        _this.updateCroppedImage = function (cropImage, uploadedImageUrl) { return __awaiter(_this, void 0, void 0, function () {
            var cacheBustedUrl, loadImage, img, originalWidth, originalHeight, originalLeft, originalTop, scaleToFitWidth, scaleToFitHeight, scale, centeredLeft, centeredTop, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cacheBustedUrl = "".concat(uploadedImageUrl, "?t=").concat(new Date().getTime());
                        loadImage = function (url) {
                            return new Promise(function (resolve, reject) {
                                fabric_1.fabric.Image.fromURL(url, function (img) {
                                    resolve(img);
                                }, { crossOrigin: 'anonymous' });
                            });
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, loadImage(cacheBustedUrl)];
                    case 2:
                        img = _a.sent();
                        originalWidth = cropImage.width * cropImage.scaleX;
                        originalHeight = cropImage.height * cropImage.scaleY;
                        originalLeft = cropImage.left;
                        originalTop = cropImage.top;
                        scaleToFitWidth = originalWidth / img.width;
                        scaleToFitHeight = originalHeight / img.height;
                        scale = Math.min(scaleToFitWidth, scaleToFitHeight);
                        centeredLeft = originalLeft + (originalWidth - (img.width * scale)) / 2;
                        centeredTop = originalTop + (originalHeight - (img.height * scale)) / 2;
                        // Set the new image properties
                        img.set({
                            type: constants_1.LayerType.STATIC_IMAGE,
                            left: centeredLeft,
                            top: centeredTop,
                            scaleX: scale,
                            scaleY: scale,
                        });
                        img.metadata = cropImage.metadata;
                        // Remove the old image and add the new one
                        this.canvas.remove(cropImage);
                        this.canvas.add(img);
                        this.canvas.setActiveObject(img);
                        this.canvas.requestRenderAll();
                        console.log("Image updated with cropped version, centered within the original dimensions.");
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Failed to load the image:", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.cloneBackground = function () {
            var background = _this.background;
            if (!background || _this.originalBackground) {
                return;
            }
            _this.originalBackground = {
                "left": background.left,
                "top": background.top,
                "originX": background.originX,
                "originY": background.originY,
            };
        };
        _this.setBackgroundGradient = function (_a) {
            var angle = _a.angle, colors = _a.colors;
            var background = _this.background;
            if (background) {
                (0, fabric_2.default)(background, angle, colors);
                _this.canvas.requestRenderAll();
                _this.editor.history.save();
            }
        };
        _this.initialize();
        return _this;
    }
    Frame.prototype.initialize = function () {
        var _this = this;
        var frame = new fabric_1.fabric.Frame(__assign(__assign({}, constants_1.defaultFrameOptions), { absolutePositioned: this.config.clipToFrame }));
        var background = new fabric_1.fabric.Background(__assign(__assign({}, constants_1.defaultBackgroundOptions), { shadow: this.config.shadow }));
        this.canvas.add(frame, background);
        var center = this.canvas.getCenter();
        frame.center();
        background.center();
        this.state.setFrame({
            height: constants_1.defaultFrameOptions.width,
            width: constants_1.defaultFrameOptions.height,
        });
        setTimeout(function () {
            _this.editor.zoom.zoomToFit();
            _this.editor.history.initialize();
        }, 50);
    };
    Object.defineProperty(Frame.prototype, "frame", {
        get: function () {
            return this.canvas.getObjects().find(function (object) { return object.type === constants_1.LayerType.FRAME; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Frame.prototype, "background", {
        get: function () {
            return this.canvas
                .getObjects()
                .find(function (object) { return object.type === constants_1.LayerType.BACKGROUND; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Frame.prototype, "options", {
        get: function () {
            var options = this.frame.toJSON(this.config.propertiesToInclude);
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Frame.prototype.resize = function (_a) {
        var height = _a.height, width = _a.width;
        this.state.setFrame({
            height: height,
            width: width,
        });
        var frame = this.frame;
        var background = this.background;
        frame.set({ width: width, height: height });
        frame.center();
        if (background) {
            background.set({ width: width, height: height });
            background.center();
        }
        this.editor.zoom.zoomToFit();
    };
    Frame.prototype.getBoundingClientRect = function () {
        var frame = this.frame;
        return frame.getBoundingRect();
    };
    Object.defineProperty(Frame.prototype, "fitRatio", {
        get: function () {
            var options = this.frame;
            var canvasWidth = this.canvas.getWidth() - this.config.frameMargin;
            var canvasHeight = this.canvas.getHeight() - this.config.frameMargin;
            var scaleX = canvasWidth / options.width;
            var scaleY = canvasHeight / options.height;
            if (options.height >= options.width) {
                scaleX = scaleY;
                if (canvasWidth < options.width * scaleX) {
                    scaleX = scaleX * (canvasWidth / (options.width * scaleX));
                }
            }
            else {
                if (canvasHeight < options.height * scaleX) {
                    scaleX = scaleX * (canvasHeight / (options.height * scaleX));
                }
            }
            return scaleX;
        },
        enumerable: false,
        configurable: true
    });
    return Frame;
}(Base_1.default));
exports.default = Frame;
//# sourceMappingURL=Frame.js.map